import {
  Component,
  Inject,
  OnInit,
  Optional,
  ElementRef,
  QueryList,
  ViewChildren,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { FindingsModel } from "../DoctorModels/findings.model";
import { InvestigationModel } from "../DoctorModels/investigation.model";
import { DiagnosisModel } from "../DoctorModels/diagnosis.model";
import { SurgeryModel } from "../DoctorModels/surgery.model";
import { EMRService } from "../EMR.service";
import { MedicineModal } from "../DoctorModels/medicine.model";
import { GetTemplateModel } from "../DoctorModels/getTemplate.model";
import { MedicineTemplateComponent } from "./medicine-template/medicine-template.component";
import { DiagnosisComponent } from "../Diagnosis/Diagnosis.component";
import { ExaminationHelpComponent } from "../ExaminationHelp/ExaminationHelp.component";
import { InvestigationServicesComponent } from "../Doctor/investigation-services/investigation-services.component";
import { HelpListPopupComponent } from "../Doctor/doctor-other-info/help-list-popup/help-list-popup.component";
import { DashboardService } from "app/dashboard/dashboard.service";
import { FormControl } from "@angular/forms";
import { Observable, Subject, zip } from "rxjs";
import { AuthService } from "app/auth/auth.service";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { map, startWith, take, takeUntil } from "rxjs/operators";
import { OtherSurgeryPopupComponent } from "../other-surgery-popup/other-surgery-popup.component";

@Component({
  selector: "app-template_help",
  templateUrl: "./template_help.component.html",
  styleUrls: ["./template_help.component.scss"],
})
export class Template_helpComponent implements OnInit {
  private rowClicked: any;
  private buttondisavbled: boolean = false;
  private progressivedescription: string = "";
  private planOfCaredescription: string = "";
  private doctorremarks: string = "";
  private DoctorCtrl: FormControl;
  private filteredDoctorArray: Observable<any[]>;
  private findings_ds: any = new MatTableDataSource<FindingsModel>();
  private investigation_ds: any = new MatTableDataSource<InvestigationModel>();
  private diagnosis_ds: any = new MatTableDataSource<DiagnosisModel>();
  private surgery_ds: any = new MatTableDataSource<SurgeryModel>();
  private medicine_ds: any = new MatTableDataSource<MedicineModal>();
  private template_ds: any = new MatTableDataSource<GetTemplateModel>();
  private displayedColumns_Template: string[] = [
    "templateName",
    "doctor",
    "Action",
  ];
  private displayedColumns_findings: string[] = [
    "examination",
    "righteye",
    "lefteye",
    "Action",
  ];
  private displayedColumns_investigations: string[] = [
    "investigation",
    "Action",
  ];
  private displayedColumns_diagnosis: string[] = [
    "icd",
    "diagnosis",
    "site",
    "Action",
  ];
  private displayedColumns_surgery: string[] = [
    "surgery",
    "site",
    "surgeon",
    "Action",
  ];
  private displayedColumns_medicine: string[] = [
    "medicine",
    "medicinetype",
    "doasage",
    "qty",
    "duration",
    "unit",
    "remarks",
    "Action",
  ];
  canModify: boolean = false;

  constructor(
    private dialog: MatDialog,
    private authService: AuthService,
    private opdvisitService: OpdVisitService,
    private emrService: EMRService,
    private dashboardService: DashboardService,
    private dialogRef: MatDialogRef<Template_helpComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    dialogRef.disableClose = true;
  }
  @ViewChildren("defaultauto") defaultautoRef: QueryList<ElementRef>;
  destroymedicine$: Subject<boolean> = new Subject<boolean>();
  private mediniceMainArray: any = [];
  private findinglistarrray: any = [];
  private surgeryMainArray: any = [];
  private investigationMainArray: any = [];
  private diagnosisMainArray: any = [];
  private dosedataArray: any = [];
  private templateArray: any = [];
  private bindteplatearray: any = {};
  ngOnInit() {
    this.mediniceMainArray = [];
    this.findinglistarrray = [];
    this.surgeryMainArray = [];
    this.investigationMainArray = [];
    this.diagnosisMainArray = [];
    this.dosedataArray = [];
    this.templateArray = [];
    this.bindteplatearray = [];
    this.findings_ds = new MatTableDataSource(this.emrService.findings.slice());
    this.investigation_ds = new MatTableDataSource(
      this.emrService.investigations.slice()
    );
    this.diagnosis_ds = new MatTableDataSource(
      this.emrService.diagnosis.slice()
    );
    this.medicine_ds = new MatTableDataSource(
      this.emrService.medicines.slice()
    );
    this.surgery_ds = new MatTableDataSource(this.emrService.surgery.slice());
    //this.departments_ds.data = this.helplistservice.surgery_departments;
    this.getTempateData(0);
    this.rowClicked = -1;
    this.GetDosageMaster(0, 0, 0);
    this.getDoctorBrach();

    this.template_ds.filterPredicate = (data, filter: string) => {
      const searchStr = filter.trim().toLowerCase();
      return (
        (data.templateName &&
          data.templateName.toLowerCase().includes(searchStr)) ||
        (data.doctor && data.doctor.toLowerCase().includes(searchStr))
      );
    };
  }
  ngOnDestroy() {
    this.destroymedicine$.next(true);
    this.destroymedicine$.unsubscribe();
    this.displayedColumns_Template = null;
    this.displayedColumns_investigations = null;
    this.displayedColumns_findings = null;
    this.displayedColumns_diagnosis = null;
    this.displayedColumns_surgery = null;
    this.displayedColumns_medicine = null;
    this.investigation_ds = null;
    this.diagnosis_ds = null;
    this.medicine_ds = null;
    this.surgery_ds = null;
    this.mediniceMainArray = null;
    this.findinglistarrray = null;
    this.surgeryMainArray = null;
    this.investigationMainArray = null;
    this.diagnosisMainArray = null;
    this.dosedataArray = null;
    this.templateArray = null;
    this.bindteplatearray = null;
    this.findings_ds = null;
  }
  clearTemplateData() {
    this.dialog.closeAll();
  }
  applyFilter_template(filterValue: string) {
    this.template_ds.filter = filterValue.trim().toLowerCase();
  }
  getTempateData(id, templateid?: number, del?: any) {
    this.templateArray = [];
    this.emrService.GetdoctorTemplate(id).subscribe((data: any) => {
      if (this.authService.Loggeduser.usertypeid == 6) {
        this.templateArray = data.filter(
          (item) =>
            item.fK_DoctorId == this.authService.Loggeduser.userid ||
            item.fK_DoctorId == 1
        );
        this.template_ds.data = data.filter(
          (item) =>
            item.fK_DoctorId == this.authService.Loggeduser.userid ||
            item.fK_DoctorId == 1
        );
      } else {
        this.templateArray = data;
        this.template_ds.data = data;
      }

      if (templateid > 0) {
        this.GetTemplatedetail(templateid, del);
      }
    });
  }
  cleardata() {
    this.buttondisavbled = false;
    this.mediniceMainArray = [];
    this.findinglistarrray = [];
    this.surgeryMainArray = [];
    this.investigationMainArray = [];
    this.diagnosisMainArray = [];
    this.findings_ds = new MatTableDataSource(this.emrService.findings.slice());
    this.investigation_ds = new MatTableDataSource(
      this.emrService.investigations.slice()
    );
    this.diagnosis_ds = new MatTableDataSource(
      this.emrService.diagnosis.slice()
    );
    this.medicine_ds = new MatTableDataSource(
      this.emrService.medicines.slice()
    );
    this.surgery_ds = new MatTableDataSource(this.emrService.surgery.slice());
  }

  //use zip method to call a api
  GetDetailsUsingZip(pK_TemplateId: any) {
    this.investigationMainArray = [];
    this.surgeryMainArray = [];
    this.mediniceMainArray = [];
    this.findinglistarrray = [];
    this.diagnosisMainArray = [];
    zip(
      this.emrService.GetInvestigationdata(0, pK_TemplateId),
      this.emrService.GetSurgerydata(0, pK_TemplateId),
      this.emrService.GetMedicineTemplate(0, pK_TemplateId),
      this.emrService.GetExaminationdata(0, pK_TemplateId),
      this.emrService.GetDiagnosisdata(0, pK_TemplateId)
    )
      .pipe(takeUntil(this.destroymedicine$))
      .subscribe(([investigationData, surgeryData, medicineData, examinationData, diagnosisData]) => {
        this.investigationMainArray = investigationData;
        if (this.investigationMainArray.length > 0) {
          this.investigation_ds = new MatTableDataSource(
            this.investigationMainArray.slice()
          );
        } else {
          this.investigation_ds = new MatTableDataSource(
            this.emrService.investigations.slice()
          );
        }
        this.surgeryMainArray = surgeryData;
        if (this.surgeryMainArray.length > 0) {
          this.surgery_ds = new MatTableDataSource(
            this.surgeryMainArray.slice()
          );
        } else {
          this.surgery_ds = new MatTableDataSource(
            this.emrService.surgery.slice()
          );
        }
        this.mediniceMainArray = medicineData;
        if (this.mediniceMainArray.length > 0) {
          this.medicine_ds = new MatTableDataSource(
            this.mediniceMainArray.slice()
          );
        } else {
          this.medicine_ds = new MatTableDataSource(
            this.emrService.medicines.slice()
          );
        }
        this.findinglistarrray = examinationData;
        if (this.findinglistarrray.length > 0) {
          this.findings_ds = new MatTableDataSource(
            this.findinglistarrray.slice()
          );
        } else {
          this.findings_ds = new MatTableDataSource(
            this.emrService.findings.slice()
          );
        }
        this.diagnosisMainArray = diagnosisData;
        if (this.diagnosisMainArray.length > 0) {
          this.diagnosis_ds = new MatTableDataSource(
            this.diagnosisMainArray.slice()
          );
        } else {
          this.diagnosis_ds = new MatTableDataSource(
            this.emrService.diagnosis.slice()
          );
        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar(
            "You Don't have Permission",
            "OK"
          );
        } else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  addTemplate() {
    this.mediniceMainArray = [];
    this.findinglistarrray = [];
    this.surgeryMainArray = [];
    this.investigationMainArray = [];
    this.diagnosisMainArray = [];
    this.findings_ds = new MatTableDataSource(this.emrService.findings.slice());
    this.investigation_ds = new MatTableDataSource(
      this.emrService.investigations.slice()
    );
    this.diagnosis_ds = new MatTableDataSource(
      this.emrService.diagnosis.slice()
    );
    this.medicine_ds = new MatTableDataSource(
      this.emrService.medicines.slice()
    );
    this.surgery_ds = new MatTableDataSource(this.emrService.surgery.slice());
    let checkdata = this.templateArray.filter(
      (item) => item.pK_TemplateId == 0
    );
    if (checkdata.length == 0) {
      let doctorId = null;
      let doctorName = null;

      if (this.authService.Loggeduser.usertypeid == 6) {
        doctorId = this.authService.Loggeduser.userid;
        doctorName = this.authService.Loggeduser.firstname;
      } else if (this.authService.Loggeduser.usertypeid == 9) {
        doctorId = this.authService.Loggeduser.userid;
        doctorName = this.authService.Loggeduser.firstname;
      }

      this.templateArray.push({
        pK_TemplateId: 0,
        templateName: "",
        fK_DoctorId: doctorId,
        reviewDays: 0,
        reviewUnit: "",
        drRemarks: "",
        treatmentPlan: "",
        prognosis: null,
        nutritionalAdvice: null,
        isActive: true,
        pk_SynchId: null,
        examinationComments: null,
        fk_LanguageId: 1,
        diagnosisComments: null,
        doctor: doctorName,
        isHidden: null,
      });
      this.template_ds.data = this.templateArray;
      this.rowClicked = -1;
    } else {
      this.dashboardService.openSnackBar("Already New Field Added", "OK");
    }
    this.defaultautoRef.changes.pipe(take(1)).subscribe({
      next: (changes) => changes.last.nativeElement.focus(),
    });
  }
  GetTemplatedetail(pK_TemplateId: any, idx?: any) {
    this.bindteplatearray = {};
    if (idx != "delete") {
      if (this.rowClicked === idx) {
        this.rowClicked = -1;
        this.cleardata();
        this.buttondisavbled = false;
      } else {
        this.buttondisavbled = true;
        let idx = this.template_ds.data.findIndex(
          (obj) => obj.pK_TemplateId === pK_TemplateId
        );
        this.rowClicked = idx;
        let searhdata = this.templateArray.filter(
          (item) => item.pK_TemplateId == pK_TemplateId
        );
        this.bindteplatearray = searhdata[0];
        if (pK_TemplateId != 0) {
          this.GetDetailsUsingZip(pK_TemplateId)

        }
      }
    } else {
      this.buttondisavbled = true;
      let searhdata = this.templateArray.filter(
        (item) => item.pK_TemplateId == pK_TemplateId
      );
      this.bindteplatearray = searhdata[0];
      if (pK_TemplateId != 0) {
        this.GetDetailsUsingZip(pK_TemplateId)
      }
    }
  }


  ontemplateName(e: any, index: number, id) {
    if (e != null) {
      this.buttondisavbled = !e ? false : true;
      this.templateArray[index].templateName = e;
      this.template_ds = new MatTableDataSource(this.templateArray.slice());
      let idx = this.template_ds.data.findIndex(
        (obj) => obj.pK_TemplateId === id
      );
      this.rowClicked = idx;
      let searhdata = this.templateArray.filter(
        (item) => item.pK_TemplateId == id
      );
      this.bindteplatearray = searhdata[0];
    }
  }
  onrightchange(e: any, index: number) {
    if (e != null) {
      this.buttondisavbled = true;
      this.findinglistarrray[index].examValues1 = e;
      this.findings_ds = new MatTableDataSource(this.findinglistarrray.slice());
    }
  }
  onleftchange(e: any, index: number) {
    if (e != null) {
      this.buttondisavbled = true;
      this.findinglistarrray[index].examValues2 = e;
      this.findings_ds = new MatTableDataSource(this.findinglistarrray.slice());
    }
  }
  enableEditmode(e: any, index: number) {
    this.buttondisavbled = true;
    this.diagnosisMainArray[index].isEdit = true;
    this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
  }
  onicdcodeChange(e: any, index: number) {
    if (e != null) {
      this.buttondisavbled = true;
      this.diagnosisMainArray[index].icdcode = e;
      this.diagnosis_ds = new MatTableDataSource(
        this.diagnosisMainArray.slice()
      );
    }
  }
  onDiagnosisChange(e: any, index: number) {
    if (e != null) {
      this.buttondisavbled = true;
      this.diagnosisMainArray[index].diagnosisName = e;
      this.diagnosis_ds = new MatTableDataSource(
        this.diagnosisMainArray.slice()
      );
    }
  }


  deletemedicine(row: any) {
    if (!row.medicineName || row.medicineName.trim() == "") {
      this.dashboardService.openSnackBar("Cannot delete blank row", "OK");
      return;
    }
    const index: number = this.mediniceMainArray.indexOf(row);
    if (index !== -1) {
      this.mediniceMainArray.splice(index, 1);
      this.medicine_ds = new MatTableDataSource(this.mediniceMainArray.slice());
    }
    this.deleteInsertdata(row, 1);
  }

  // delete findind data
  removeRow(row: any) {
    if (!row.findingName || row.findingName.trim() === "") {
      this.dashboardService.openSnackBar("Cannot delete blank row", "OK");
      return;
    }

    const index: number = this.findinglistarrray.indexOf(row);
    if (index !== -1) {
      this.findinglistarrray.splice(index, 1);
      this.findings_ds = new MatTableDataSource(this.findinglistarrray.slice());
    }
    this.deleteInsertdata(row, 3);
  }
  //delelte surgery
  deletesurgery(row: any) {
    if (!row.surgeryName || row.surgeryName.trim() === "") {
      this.dashboardService.openSnackBar("Cannot delete blank row", "OK");
      return;
    }
    const index: number = this.surgeryMainArray.indexOf(row);
    if (index !== -1) {
      this.surgeryMainArray.splice(index, 1);
      this.surgery_ds.data = this.surgeryMainArray;
    }
    if (this.surgeryMainArray.length == 0) {
      this.surgery_ds = new MatTableDataSource(this.emrService.surgery.slice());
    }
    this.deleteInsertdata(row, 5);
  }
  //delete investigation
  deleteinvestigation(row: any) {
    if (!row.serviceName || row.serviceName.trim() === "") {
      this.dashboardService.openSnackBar("Cannot delete blank row", "OK");
      return;
    }
    const index: number = this.investigationMainArray.indexOf(row);
    if (index !== -1) {
      this.investigationMainArray.splice(index, 1);
      this.investigation_ds.data = this.investigationMainArray;
    }
    if (this.investigationMainArray.length == 0) {
      this.investigation_ds = new MatTableDataSource(
        this.emrService.investigations.slice()
      );
    }
    this.deleteInsertdata(row, 4);
  }
  // delete diagonsis
  deleteDiagnosis(row: any) {
    if (
      (!row.diagnosisName || row.diagnosisName.trim() === "") &&
      (!row.icdcode || row.icdcode.trim() === "")
    ) {
      this.dashboardService.openSnackBar("Cannot delete blank row", "OK");
      return;
    }
    const index: number = this.diagnosisMainArray.indexOf(row);
    if (index !== -1) {
      this.diagnosisMainArray.splice(index, 1);
      this.diagnosis_ds = new MatTableDataSource(
        this.diagnosisMainArray.slice()
      );
    }
    if (this.diagnosisMainArray.length == 0) {
      this.diagnosis_ds = new MatTableDataSource(
        this.emrService.diagnosis.slice()
      );
    }
    this.deleteInsertdata(row, 2);
  }

  // changeTableRowColor(idx: any) {
  //   if (this.rowClicked === idx) {

  //     this.rowClicked = -1;
  //     this.cleardata();
  //     this.buttondisavbled =false;
  //   }
  //   else {
  //     this.buttondisavbled =true;
  //     this.rowClicked = idx;
  //   }

  // }
  GetDosageMaster(doseid, type, seachtype) {
    this.dosedataArray = [];
    this.emrService
      .GetDosageMaster(doseid, type, seachtype)
      .subscribe((item) => {
        this.dosedataArray = item;
      });
  }
  onDoctorchange(e: any, index: number, pK_TemplateId) {
    if (e != null) {
      this.rowClicked = index;
      this.buttondisavbled = true;
      this.templateArray[index].fK_DoctorId = e;
      this.template_ds = new MatTableDataSource(this.templateArray.slice());

      let idx = this.template_ds.data.findIndex(
        (obj) => obj.pK_TemplateId === pK_TemplateId
      );
      this.rowClicked = idx;
      let searhdata = this.templateArray.filter(
        (item) => item.pK_TemplateId == pK_TemplateId
      );
      this.bindteplatearray = searhdata[0];
    }
  }
  onDosechange(e: any, index: number) {
    if (e != null) {
      this.buttondisavbled = true;
      let doseid = this.dosedataArray.filter((item) => item.dosageCode == e);
      this.mediniceMainArray[index].fK_DosageId = doseid[0].pK_DosageId;
      this.mediniceMainArray[index].dosageCode = e;
      this.medicine_ds = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  onUnitchange(e: any, index: number) {
    if (e != null) {
      this.buttondisavbled = true;
      this.mediniceMainArray[index].daysUnit = e;
      this.mediniceMainArray[index].unit = e;
      this.medicine_ds = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  ondaysChange(e: any, index: number) {
    if (e != null) {
      this.buttondisavbled = true;
      this.mediniceMainArray[index].days = e;
      this.medicine_ds = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  onremarkschange(e: any, index: number) {
    if (e != null) {
      this.buttondisavbled = true;
      this.mediniceMainArray[index].remarks = e;
      this.medicine_ds = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  medicineType(e: any, index: number) {
    if (e != null) {
      this.buttondisavbled = true;
      this.mediniceMainArray[index].medicineType = e;
      this.medicine_ds = new MatTableDataSource(this.mediniceMainArray.slice());
    }
  }
  onQtychange(e: any, index: number) {
    if (e != null && e > 0) {
      this.mediniceMainArray[index].qty = e;
      this.medicine_ds = new MatTableDataSource(this.mediniceMainArray.slice());
    } else {
      this.mediniceMainArray[index].qty = 1;
      this.medicine_ds = new MatTableDataSource(this.mediniceMainArray.slice());
    }
    this.buttondisavbled = true;
  }
  onSitechange(e: any, index: number) {
    if (e != null) {
      this.buttondisavbled = true;
      this.surgeryMainArray[index].remarks = e;
      this.surgeryMainArray[index].site = e;
      this.surgery_ds = new MatTableDataSource(this.surgeryMainArray.slice());
    }
  }
  ondSitechange(e: any, index: number) {
    if (e != null) {
      this.buttondisavbled = true;
      this.diagnosisMainArray[index].site = e;
      this.diagnosisMainArray[index].remarks = e;
      this.diagnosis_ds = new MatTableDataSource(
        this.diagnosisMainArray.slice()
      );
    }
  }
  //medinice template
  OpenMediniceTemplate() {
    if (this.rowClicked == -1) {
      this.dashboardService.openSnackBar(
        "Please select a template first.",
        "OK"
      );
      return;
    }
    if (this.canModify == true) {
      this.dashboardService.openSnackBar(
        "You can only modify your own templates",
        "OK"
      );
      return;
    }
    const dialogRef = this.dialog.open(MedicineTemplateComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "90%",
      width: "80%",
      data: {
        RateType: 1,
        BillEntryId: 1,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroymedicine$))
      .subscribe((result) => {
        if (result.length > 0) {
          this.buttondisavbled = true;
          this.mediniceMainArray = this.mediniceMainArray.concat(result);
          this.medicine_ds = new MatTableDataSource(
            this.mediniceMainArray.slice()
          );
        }
      });
  }

  closedialog() {
    this.dialog.closeAll();
  }
  openexamination(): void {
    if (this.rowClicked == -1) {
      this.dashboardService.openSnackBar(
        "Please select a template first.",
        "OK"
      );
      return;
    }
    if (this.canModify == true) {
      this.dashboardService.openSnackBar(
        "You can only modify your own templates",
        "OK"
      );
      return;
    }

    const dialogRef = this.dialog.open(ExaminationHelpComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "90vw",
      width: "90%",
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroymedicine$))
      .subscribe((result) => {
        if (result.length > 0) {
          this.buttondisavbled = true;
          this.findinglistarrray = this.findinglistarrray.concat(result);
          this.findings_ds = new MatTableDataSource(
            this.findinglistarrray.slice()
          );
        }

        console.log("The dialog was closed");
      });
  }

  newservice() {
    if (this.rowClicked == -1) {
      this.dashboardService.openSnackBar(
        "Please select a template first.",
        "OK"
      );
      return;
    }
    if (this.canModify == true) {
      this.dashboardService.openSnackBar(
        "You can only modify your own templates",
        "OK"
      );
      return;
    }
    const dialogRef = this.dialog.open(InvestigationServicesComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "90%",
      width: "80%",
    });

    dialogRef.afterClosed().subscribe((result) => {
      let newresult = this.emrService.selectedInvestigationRow.reduce(
        (unique, o) => {
          if (
            !unique.some(
              (obj) =>
                obj.serviceName === o.serviceName &&
                obj.FK_ServiceId === o.FK_ServiceId
            )
          ) {
            unique.push(o);
          }
          return unique;
        },
        []
      );
      if (newresult.length > 0) {
        this.buttondisavbled = true;
        this.investigationMainArray =
          this.investigationMainArray.concat(newresult);
        this.investigation_ds = new MatTableDataSource(
          this.investigationMainArray.slice()
        );
      }
    });
  }

  newsurgery() {
    if (this.rowClicked == -1) {
      this.dashboardService.openSnackBar(
        "Please select a template first.",
        "OK"
      );
      return;
    }
    if (this.canModify == true) {
      this.dashboardService.openSnackBar(
        "You can only modify your own templates",
        "OK"
      );
      return;
    }
    const dialogRef = this.dialog.open(OtherSurgeryPopupComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "90vw",
      disableClose: true,
      width: "80%",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.length > 0) {
        this.buttondisavbled = true;
        var resultt = result.reduce((unique, o) => {
          if (
            !unique.some(
              (obj) =>
                obj.surgeryName === o.surgeryName &&
                obj.fK_SurgeryId === o.fK_SurgeryId
            )
          ) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.surgeryMainArray = this.surgeryMainArray.concat(resultt);
        this.surgery_ds = new MatTableDataSource(this.surgeryMainArray.slice());
      }
    });
  }

  opendiagnosis(): void {
    if (this.rowClicked == -1) {
      this.dashboardService.openSnackBar(
        "Please select a template first.",
        "OK"
      );
      return;
    }
    if (this.canModify == true) {
      this.dashboardService.openSnackBar(
        "You can only modify your own templates",
        "OK"
      );
      return;
    }
    const dialogRef = this.dialog.open(DiagnosisComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "90vw",
      width: "90%",
      disableClose: true,
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroymedicine$))
      .subscribe((result) => {
        if (result.length > 0) {
          this.buttondisavbled = true;
          this.diagnosisMainArray = this.diagnosisMainArray.concat(result);
          this.diagnosis_ds = new MatTableDataSource(
            this.diagnosisMainArray.slice()
          );
        }
      });
  }

  refReasonPOpup(type) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",

      data: {
        typeid: type,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result != 0) {
        this.buttondisavbled = true;
        if (type == 46) {
          this.bindteplatearray.prognosis = result;
          // this.progressivedescription = result;
        } else if (type == 45) {
          //  this.planOfCaredescription = result;
          this.bindteplatearray.treatmentPlan = result;
        }
      }
    });
  }
  medicineArray: any = [];
  diagnosisArraya: any = [];
  examArray: any = [];
  investigation: any = [];
  surgeryArray: any = [];
  InsertTemplate(event) {
    if (this.rowClicked == -1) {
      this.dashboardService.openSnackBar(
        "Please select a template first.",
        "OK"
      );
      return;
    }

    if (this.canModify == true) {
      this.dashboardService.openSnackBar(
        "You can only modify your own templates",
        "OK"
      );
      return;
    }
    const button =
      event.srcElement.disabled === undefined
        ? event.srcElement.parentElement
        : event.srcElement;
    button.setAttribute("disabled", true);

    this.medicineArray = [];
    this.diagnosisArraya = [];
    this.examArray = [];
    this.investigation = [];
    this.surgeryArray = [];

    if (this.mediniceMainArray.length > 0) {
      this.mediniceMainArray.forEach((item) => {
        this.medicineArray.push({
          PK_TempPresDetailId: item.pK_TempPresDetailId
            ? item.pK_TempPresDetailId
            : 0,
          FK_MedicineId: item.pK_MedicineId
            ? item.pK_MedicineId
            : item.fK_MedicineId,
          FK_TemplateId: this.bindteplatearray.pK_TemplateId
            ? this.bindteplatearray.pK_TemplateId
            : 0,
          Qty: item.qty,
          FK_DosageId: item.fK_DosageId,
          Days: item.days,
          Unit: item.unit ? item.unit : item.daysUnit,
          Remarks: item.remarks,
          IsHidden: 0,
          IsEdit: item.pK_TempPresDetailId ? 1 : 0,
        });
      });
    }
    if (this.diagnosisMainArray.length > 0) {
      this.diagnosisMainArray.forEach((item) => {
        this.diagnosisArraya.push({
          PK_TempDiagnosisDetailId: item.pK_TempDiagnosisDetailId
            ? item.pK_TempDiagnosisDetailId
            : 0,
          FK_TemplateId: this.bindteplatearray.pK_TemplateId
            ? this.bindteplatearray.pK_TemplateId
            : 0,
          FK_DiagnosisId: item.pk_DiagnosisId
            ? item.pk_DiagnosisId
            : item.fK_DiagnosisId,
          Remarks: item.remarks ? item.remarks : item.site,
          IsHidden: 0,
          IsEdit: item.pK_TempDiagnosisDetailId ? 1 : 0,
        });
      });
    }
    if (this.findinglistarrray.length > 0) {
      this.findinglistarrray.forEach((item) => {
        this.examArray.push({
          PK_TempExamDetailId: item.pK_TempExamDetailId
            ? item.pK_TempExamDetailId
            : 0,
          FK_TemplateId: this.bindteplatearray.pK_TemplateId
            ? this.bindteplatearray.pK_TemplateId
            : 0,
          Fk_FindingId: item.fk_FindingId
            ? item.fk_FindingId
            : item.pk_FindingId,
          ExamValues1: item.examValues1,
          ExamValues2: item.examValues2,
          Specification: item.specification,
          IsHidden: 0,
          IsEdit: item.pK_TempExamDetailId ? 1 : 0,
        });
      });
    }
    if (this.investigationMainArray.length > 0) {
      this.investigationMainArray.forEach((item) => {
        this.investigation.push({
          PK_TempInvDetailId: item.pK_TempInvDetailId
            ? item.pK_TempInvDetailId
            : 0,
          FK_TemplateId: this.bindteplatearray.pK_TemplateId
            ? this.bindteplatearray.pK_TemplateId
            : 0,
          FK_ServiceId: item.serviceId ? item.serviceId : item.fK_ServiceId,
          IsHidden: 0,
          IsEdit: 1,
        });
      });
    }
    if (this.surgeryMainArray.length > 0) {
      this.surgeryMainArray.forEach((item) => {
        this.surgeryArray.push({
          PK_TempSurgeryDetailId: item.pK_TempSurgeryDetailId
            ? item.pK_TempSurgeryDetailId
            : 0,
          FK_TemplateId: this.bindteplatearray.pK_TemplateId
            ? this.bindteplatearray.pK_TemplateId
            : 0,
          FK_surgeryId: item.pkSurgeryId ? item.pkSurgeryId : item.fK_surgeryId,
          Remarks: item.site,
          IsHidden: 0,
          IsEdit: 1,
        });
      });
    }

    let payload = {
      TemplateMasterDto: {
        PK_TemplateId: this.bindteplatearray.pK_TemplateId
          ? this.bindteplatearray.pK_TemplateId
          : 0,
        FK_DoctorId: this.bindteplatearray.fK_DoctorId,
        ReviewDays: this.bindteplatearray.reviewDays,
        ReviewUnit: this.bindteplatearray.reviewUnit,
        TemplateName: this.bindteplatearray.templateName,
        DrRemarks: this.bindteplatearray.drRemarks,
        TreatmentPlan: this.bindteplatearray.treatmentPlan,
        Prognosis: this.bindteplatearray.prognosis,
        NutritionalAdvice: this.bindteplatearray.nutritionalAdvice,
        IsActive: true,
        ExaminationComments: this.bindteplatearray.examinationComments,
        Fk_LanguageId: this.bindteplatearray.fk_LanguageId,
        DiagnosisComments: this.bindteplatearray.diagnosisComments,
        IsHidden: 0,
      },
      TemplatePrescriptionDetailDto: this.medicineArray,
      TemplateDiagnosisDetailDto: this.diagnosisArraya,
      TemplateExaminationDetailDto: this.examArray,
      TemplateInvestigationDetailDto: this.investigation,
      TemplatSurgeryDto: this.surgeryArray,
    };
    this.emrService.InsertTemplate(payload).subscribe(
      (data: any) => {
        if (data["statusCode"] == 1) {
          this.buttondisavbled = true;
          this.getTempateData(0, data["id"]);
          button.removeAttribute("disabled");
          this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
          this.rowClicked == -1;
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
        this.buttondisavbled = true;
        button.removeAttribute("disabled");
        // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
      }
    );
  }

  deleteInsertdata(row, type) {
    this.medicineArray = [];
    this.diagnosisArraya = [];
    this.examArray = [];
    this.investigation = [];
    this.surgeryArray = [];
    if (type == 1) {
      if (row.pK_TempPresDetailId > 0 && row.pK_TempPresDetailId != undefined) {
        this.medicineArray.push({
          PK_TempPresDetailId: row.pK_TempPresDetailId,
          FK_TemplateId: this.bindteplatearray.pK_TemplateId
            ? this.bindteplatearray.pK_TemplateId
            : 0,
          FK_MedicineId: row.pK_MedicineId
            ? row.pK_MedicineId
            : row.fK_MedicineId,
          Qty: row.qty,
          FK_DosageId: row.fK_DosageId,
          Days: row.days,
          Unit: row.unit ? row.unit : row.daysUnit,
          Remarks: row.remarks,
          IsHidden: 1,
          IsEdit: 1,
        });
      }
    }
    if (type == 2) {
      if (
        row.pK_TempDiagnosisDetailId > 0 &&
        row.pK_TempDiagnosisDetailId != undefined
      ) {
        this.diagnosisArraya.push({
          PK_TempDiagnosisDetailId: row.pK_TempDiagnosisDetailId,
          FK_TemplateId: this.bindteplatearray.pK_TemplateId
            ? this.bindteplatearray.pK_TemplateId
            : 0,
          FK_DiagnosisId: row.pk_DiagnosisId
            ? row.pk_DiagnosisId
            : row.fK_DiagnosisId,
          Remarks: row.remarks ? row.remarks : row.site,
          IsHidden: 1,
          IsEdit: 1,
        });
      }
    }
    if (type == 3) {
      if (row.pK_TempExamDetailId > 0 && row.pK_TempExamDetailId != undefined) {
        this.examArray.push({
          PK_TempExamDetailId: row.pK_TempExamDetailId,
          FK_TemplateId: this.bindteplatearray.pK_TemplateId
            ? this.bindteplatearray.pK_TemplateId
            : 0,
          Fk_FindingId: row.fk_FindingId ? row.fk_FindingId : row.pk_FindingId,
          ExamValues1: row.examValues1,
          ExamValues2: row.examValues2,
          Specification: row.specification,
          IsHidden: 1,
          IsEdit: 1,
        });
      }
    }
    if (type == 4) {
      if (row.pK_TempInvDetailId > 0 && row.pK_TempInvDetailId != undefined) {
        this.investigation.push({
          PK_TempInvDetailId: row.pK_TempInvDetailId,
          FK_TemplateId: this.bindteplatearray.pK_TemplateId
            ? this.bindteplatearray.pK_TemplateId
            : 0,
          FK_ServiceId: row.serviceId ? row.serviceId : row.fK_ServiceId,
          IsHidden: 1,
          IsEdit: 1,
        });
      }
    }
    if (type == 5) {
      if (
        row.pK_TempSurgeryDetailId > 0 &&
        row.pK_TempSurgeryDetailId != undefined
      ) {
        this.surgeryArray.push({
          PK_TempSurgeryDetailId: row.pK_TempSurgeryDetailId,
          FK_TemplateId: this.bindteplatearray.pK_TemplateId
            ? this.bindteplatearray.pK_TemplateId
            : 0,
          FK_surgeryId: row.pkSurgeryId ? row.pkSurgeryId : row.fK_surgeryId,
          Remarks: row.site,
          IsHidden: 1,
          IsEdit: 1,
        });
      }
    }
    let payload = {
      TemplateMasterDto: {
        PK_TemplateId: this.bindteplatearray.pK_TemplateId
          ? this.bindteplatearray.pK_TemplateId
          : 0,
        FK_DoctorId: this.bindteplatearray.fK_DoctorId,
        ReviewDays: this.bindteplatearray.reviewDays,
        ReviewUnit: this.bindteplatearray.reviewUnit,
        TemplateName: this.bindteplatearray.templateName,
        DrRemarks: this.bindteplatearray.drRemarks,
        TreatmentPlan: this.bindteplatearray.treatmentPlan,
        Prognosis: this.bindteplatearray.prognosis,
        NutritionalAdvice: this.bindteplatearray.nutritionalAdvice,
        IsActive: true,
        ExaminationComments: this.bindteplatearray.examinationComments,
        Fk_LanguageId: this.bindteplatearray.fk_LanguageId,
        DiagnosisComments: this.bindteplatearray.diagnosisComments,
        IsHidden: 0,
      },
      TemplatePrescriptionDetailDto: this.medicineArray,
      TemplateDiagnosisDetailDto: this.diagnosisArraya,
      TemplateExaminationDetailDto: this.examArray,
      TemplateInvestigationDetailDto: this.investigation,
      TemplatSurgeryDto: this.surgeryArray,
    };
    if (
      this.medicineArray.length > 0 ||
      this.diagnosisArraya.length > 0 ||
      this.examArray.length > 0 ||
      this.investigation.length > 0 ||
      this.surgeryArray.length > 0
    ) {
      this.emrService.InsertTemplate(payload).subscribe(
        (data: any) => {
          if (data["statusCode"] == 1) {
            this.getTempateData(0, data["id"], "delete");
            this.dashboardService.openSnackBar(
              "Record Deleted Successfully",
              "OK"
            );
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
          // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
        }
      );
    } else {
      this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
    }
  }
  //get schedule type
  getDoctorBrach() {
    this.dashboardService.getall_doctors().subscribe(
      (data) => this.success_doctors(data),
      (err) => this.failed_doctors(err)
    );
  }

  success_doctors(data) {
    if (this.authService.masterdata.isExternal === true) {
      this.opdvisitService.doctors = data.filter(
        (item) => item.isExternal == false
      );
    } else {
      this.opdvisitService.doctors = data;
    }
  }
  failed_doctors(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  TransferDataOther(mddata, examdata, sugerydata, invdata, diagodata, type) {
    if (this.rowClicked == -1) {
      this.dashboardService.openSnackBar(
        "Please select a template first.",
        "OK"
      );
      return;
    }
    if (this.canModify == true) {
      this.dashboardService.openSnackBar(
        "You can only modify your own templates",
        "OK"
      );
      return;
    }

    let datatranser = {
      medicinerow: mddata.filter((item) => item.medicineName != ""),
      examrow: examdata.filter((item) => item.findingName != ""),
      surgeryrow: sugerydata.filter((item) => item.surgeryName != ""),
      invrow: invdata.filter((item) => item.serviceName != ""),
      diagodata: diagodata.filter((item) => item.diagnosisName != ""),
      type: type,
      drRemarks: this.bindteplatearray.drRemarks
        ? this.bindteplatearray.drRemarks
        : null,
      prognosis: this.bindteplatearray.prognosis
        ? this.bindteplatearray.prognosis
        : null,
      treatmentPlan: this.bindteplatearray.treatmentPlan
        ? this.bindteplatearray.treatmentPlan
        : null,
      diagnosisComments: this.bindteplatearray.diagnosisComments
        ? this.bindteplatearray.diagnosisComments
        : null,
    };
    this.dialogRef.close(datatranser);
  }

  handleDeleteClick(template: any) {
    const loggedUser = this.authService.Loggeduser;

    if (loggedUser && loggedUser.usertypeid == 9) {
      this.deleteTemplate(template);
      return;
    }

    if (template.fK_DoctorId === loggedUser.userid) {
      this.deleteTemplate(template);
      return;
    }

    this.dashboardService.openSnackBar(
      "You can only delete your own templates",
      "OK"
    );
  }

  onRowClick(element: any, index: number) {
    this.canModify = false;
    const loggedUser = this.authService.Loggeduser;

    if (
      loggedUser.usertypeid === 9 ||
      element.fK_DoctorId == loggedUser.userid
    ) {
    } else {
      this.dashboardService.openSnackBar(
        "You can only modify your own templates",
        "OK"
      );
      this.canModify = true;
    }
  }

  deleteTemplate(template: any) {
    if (!template || !template.pK_TemplateId) {
      this.dashboardService.openSnackBar("Invalid template to delete", "OK");
      return;
    }

    let payload = {
      TemplateMasterDto: {
        PK_TemplateId: template.pK_TemplateId,
        FK_DoctorId: template.fK_DoctorId,
        ReviewDays: template.reviewDays,
        ReviewUnit: template.reviewUnit,
        TemplateName: template.templateName,
        DrRemarks: template.drRemarks,
        TreatmentPlan: template.treatmentPlan,
        Prognosis: template.prognosis,
        NutritionalAdvice: template.nutritionalAdvice,
        IsActive: true,
        ExaminationComments: template.examinationComments,
        Fk_LanguageId: template.fk_LanguageId,
        DiagnosisComments: template.diagnosisComments,
        IsHidden: 1,
      },
      TemplatePrescriptionDetailDto: [],
      TemplateDiagnosisDetailDto: [],
      TemplateExaminationDetailDto: [],
      TemplateInvestigationDetailDto: [],
      TemplatSurgeryDto: [],
    };

    this.emrService.InsertTemplate(payload).subscribe(
      (data: any) => {
        if (data["statusCode"] == 1) {
          this.dashboardService.openSnackBar(
            "Template deleted successfully",
            "OK"
          );
          this.getTempateData(0);
          this.rowClicked = -1;
          this.mediniceMainArray = [];
          this.findinglistarrray = [];
          this.surgeryMainArray = [];
          this.investigationMainArray = [];
          this.diagnosisMainArray = [];
          this.findings_ds = new MatTableDataSource(
            this.emrService.findings.slice()
          );
          this.investigation_ds = new MatTableDataSource(
            this.emrService.investigations.slice()
          );
          this.diagnosis_ds = new MatTableDataSource(
            this.emrService.diagnosis.slice()
          );
          this.medicine_ds = new MatTableDataSource(
            this.emrService.medicines.slice()
          );
          this.surgery_ds = new MatTableDataSource(
            this.emrService.surgery.slice()
          );
        }
      },
      (err) => {
        if (err.status === 403) {
          this.dashboardService.openSnackBar("You don't have permission", "OK");
        } else if (err.error.statusCode === 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
}
